import { useParams } from 'react-router-dom';

import { usePublicClient, useWalletClient } from 'shared/hooks/use-web3';
import { useAccount } from 'shared/hooks/use-web3';
import { useRoomStore } from 'shared/store/roomStore';

export const useCloseUnusedRoom = () => {
  const { activeRoomId } = useParams();

  const { chainId, address } = useAccount();

  const publicClient = usePublicClient();
  const walletClient = useWalletClient();

  const { isSuccessfullyClosedRoom, isTechnicalDefeatError, closeRoomAction } = useRoomStore();

  const closeUnusedRoomHandler = async () => {
    try {
      await closeRoomAction({
        chainId,
        publicClient,
        roomId: BigInt(activeRoomId),
        userAddress: address,
        walletClient,
      });
    } catch (error) {}
  };

  return {
    closeUnusedRoomHandler,
    isSuccess: isSuccessfullyClosedRoom,
    technicalDefeatError: isTechnicalDefeatError,
  };
};
